import React from "react";
import { CLIENT_TYPES } from "./content";

export default function ClientMarquee() {
  const items = [...CLIENT_TYPES, ...CLIENT_TYPES];
  return (
    <section
      className="py-12 lg:py-16 bg-[var(--vw-paper)] border-y border-black/5"
      data-testid="client-marquee"
    >
      <div className="vw-container mb-8">
        <div className="flex items-center gap-3">
          <span className="vw-rule-gold" />
          <span className="vw-overline">Working with</span>
        </div>
      </div>
      <div className="vw-marquee">
        <div className="vw-marquee__track">
          {items.map((t, i) => (
            <span
              key={i}
              className="font-display text-3xl md:text-5xl lg:text-6xl font-light tracking-tight text-[var(--vw-navy)]/80 whitespace-nowrap"
            >
              {t}
              <span className="mx-6 text-[var(--vw-gold)]">◆</span>
            </span>
          ))}
        </div>
        <div className="vw-marquee__track" aria-hidden="true">
          {items.map((t, i) => (
            <span
              key={`b${i}`}
              className="font-display text-3xl md:text-5xl lg:text-6xl font-light tracking-tight text-[var(--vw-navy)]/80 whitespace-nowrap"
            >
              {t}
              <span className="mx-6 text-[var(--vw-gold)]">◆</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
